var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.43 4.7a.6.6 0 01.592.493c.08.46 2.095 12.21-7.752 17.237-.08.05-.18.07-.27.07-.09 0-.18-.02-.27-.07C1.838 17.38 3.917 5.546 3.979 5.197V5.19a.6.6 0 01.59-.49c3.377 0 6.772-2.826 7.026-3.038a.595.595 0 01.805-.012c.03.03 3.55 3.05 7.03 3.05zM5.09 5.88C4.79 8.05 4.08 16.96 12 21.22c7.83-4.21 7.19-13.19 6.91-15.34-3.05-.21-5.89-2.21-6.91-3.01-1.02.8-3.86 2.8-6.91 3.01zm6.91.33a2.701 2.701 0 00-1.905 4.613A4.4 4.4 0 007.6 14.79c0 .33.27.6.6.6h7.6c.33 0 .6-.27.6-.6a4.4 4.4 0 00-2.495-3.967A2.701 2.701 0 0012 6.21zm0 4.18c.071 0 .142.002.213.005A1.498 1.498 0 0013.5 8.91c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .758.558 1.382 1.287 1.485.07-.003.141-.005.213-.005zm-3.14 3.8a3.2 3.2 0 012.897-2.59 2.715 2.715 0 00.486 0 3.2 3.2 0 012.897 2.59H8.86z"
  })));
}

export default SvgUserShield;